/**
 * @generated SignedSource<<9f4a631625cfd161724269a0e50387ed>>
 * @relayHash 3e60bb4194bca84eae3e8f6823355ce4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6c1776f0b66b52f982b8f9eb515461db64ea674aa56b161a07e48a443eab5ea1

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BusinessSummarySpaAppsQuery } from './BusinessSummarySpaAppsQuery.graphql';

const node: PreloadableConcreteRequest<BusinessSummarySpaAppsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "6c1776f0b66b52f982b8f9eb515461db64ea674aa56b161a07e48a443eab5ea1",
    "metadata": {},
    "name": "BusinessSummarySpaAppsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
